/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_quote";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_quote";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { IShopCooktop } from "api/types/shop_quote/cooktop";
/// URLS ///
import { url_prefix } from "settings";
import { shop_cooktop_url } from "../../endpoints";

export const updateShopCooktop = (cooktop: IShopCooktop, id?: number, rotating?: boolean) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SHOP_QUOTE_UPDATING
    });

    dispatch({
      type: ActionType.UPDATE_LOCAL_SHOP_COOKTOP,
      payload: cooktop
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${shop_cooktop_url}/${id ? id : 0}/?uuid=${cooktop.uuid}&`;

    if (rotating) {
      url += "rotating=true&";
    }

    try {
      await axios.patch(url, cooktop, config);

      dispatch({
        type: ActionType.SHOP_QUOTE_ACTION_SUCCESS
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_QUOTE_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
